import React, {useEffect, useState, useMemo} from "react";
import moment from "moment";
import "moment/locale/nb";

import "../../../style/PriorityTableStyles/duedate.css";

enum DueDateCondition {
    NONE,
    NEAR,
    PASSED,
    NORMAL,
}

export default function DueDate({duedate}: { duedate: string }) {
    const [duedateCondition, setDuedateCondition] = useState<DueDateCondition>(DueDateCondition.NONE);

    const formattedDuedate = useMemo(() => duedate ? moment(duedate).format("DD.MM.YYYY") : "", [duedate]);

    useEffect(() => {
        if (!duedate) {
            setDuedateCondition(DueDateCondition.NONE);
            return;
        }

        const today = moment();
        const duedateMoment = moment(duedate);
        const diff = today.diff(duedateMoment, "days");

        if (diff > 0) {
            setDuedateCondition(DueDateCondition.PASSED);
        } else if (diff > -30) {
            setDuedateCondition(DueDateCondition.NEAR);
        } else {
            setDuedateCondition(DueDateCondition.NORMAL);
        }
    }, [duedate]);

    return (
        <div>
            {duedateCondition === DueDateCondition.NEAR && (
                <div className="deadline near-deadline">
                    <span className="deadline-circle yellow-circle"></span>
                    {formattedDuedate}
                </div>
            )}
            {duedateCondition === DueDateCondition.PASSED && (
                <div className="deadline passed-deadline"><span
                    className="deadline-circle red-circle"></span>{formattedDuedate}</div>
            )}
            {duedateCondition === DueDateCondition.NORMAL && (
                <div><span className="deadline-circle"></span>{formattedDuedate}</div>
            )}
        </div>
    );
}
